<template>
    <div class="d-flex flex-column con h-100 mb-3">
        <section class="py-2">
            <div class="container px-3 m-0 py-0" style="max-width: 100%;">
                <div class="row">
                    <div class="col-md-5 form-group">
                        <label class="fw-500">Category *</label>
                        <select class="form-control" v-model="category">
                            <option v-if="loading_rm "> 
                                        <span class="sr-only">Loading...</span>
                            </option>
                            <option v-for="(category, i) in categories" :key="i" :value="{'flag':category.cat_flag, 'name':category.category}" >{{category.category}}</option>
                        </select>
                    </div>
                </div>  
                <div class="row">
                    <div class="col-md-5 form-group">
                        <label class="fw-500">Reference Type / Number *</label>

                        <div class="input-group">
                            <select class="form-control flex-0 w-auto" v-model="i_reftype" v-on:change="resetTag" v-if="category.flag == 'Y'">
                                <option v-for="(doctype, index) in doctypes" :key="index" :value="{'flag': doctype.flag, 'id': doctype.id}" >{{doctype.name}}</option>
                            </select>
                            <input type="text" class="form-control" v-model="i_reftype" v-else :disabled="checkRef" />
                            
                            <input type="text" class="form-control flex-1" v-model="i_refno" placeholder=""/>
                        </div>
                    </div>
                    <div class="col-md-2 form-group">
                        <jl-button :class="'btn btn-dark ml-2 btn-search'" :eventClick="search" >Search</jl-button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-5 form-group">
                        <div class="row">
                            <div class="col-12">
                                <label class="fw-500">Particular</label>
                                <input type="text" class="form-control" v-model="particular" />
                            </div>
                            <div class="col-12">
                                <label class="fw-500">Description</label>
                                <textarea class="form-control" v-model="description" rows="5">

                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end of container-->
        </section>
        <!--end of section-->
        <section class="py-0 flex-1 sec1"  style="margin-left:20px; margin-right:20px;">
        <div class="container m-0 w-100 p-0 h-100" style="max-width: 100%;">
            <div class="d-flex flex-row h-100">
                <div class="card reference-sticky mb-0 br-0 d-none d-lg-flex flex-column">
                    <div class="position-relative flex-1" v-if="category.flag === 'Y'">
                        <div class="position-absolute overflow-auto w-100 h-100">
                            <div class="list-group list-group-flush">
                                <a class="list-group-item d-flex justify-content-between" v-for="doctype in doctypes" :key="doctype.id">
                                    <div>
                                        <span class="fw-500">{{doctype.name}}</span>
                                    </div>
                                    <div class="text-right">
                                        {{response[doctype.id]}}
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="d-block d-lg-none">
                        <button class="btn btn-block btn-dark py-2" data-toggle="collapse" data-target=".reference-sticky">Close</button>
                    </div>
                </div> 
                <div class="card flex-1 mb-0 br-0">


                    <div class="card-body p-0 d-flex flex-column" style="min-height: 344px; ">
                        <div class="d-flex align-items-center m-2 " style="justify-content: space-between;" >
                            <button class="btn btn-dark d-block d-lg-none" data-toggle="collapse" data-target=".reference-sticky">
                                <i class="icon-menu"></i></button>

                            <div class="btn-group ml-2" v-if="uploads.filter(upload => { return (upload.selected == true) }).length > 0" @click="removeSelected">
                                <button class="btn btn-danger">
                                    <i class="icon-trash d-block d-lg-none"></i>
                                    <span class="d-none d-lg-block">Remove</span>
                                </button>
                            </div>

                            <!-- <jl-button :class="'btn btn-success ml-auto'" :eventClick="browseFile" v-if="validSearch">
                                <i class="icon-plus mr-2"></i> Add File
                            </jl-button> -->
                            <div class="dropdown ml-auto" v-if="validSearch">
                                <button class="btn btn-success dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="icon-plus mr-2"></i> Select File
                                </button>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item" @click="browseFile">Add File</a>
                                    <a class="dropdown-item" data-toggle="modal" data-target="#modal-embed">Add Link</a>
                                </div>
                            </div>
                        </div>
                        
                        <div class="position-relative flex-1 h-100 ">
                            <div class="position-absolute w-100 h-100 overflow-auto">
                                <table class="table align-items-center table-mobile mb-0" v-if="uploads.length">
                                    <thead>
                                    <tr>
                                        <th class="bg-light" scope="col" width="40%">File</th>
                                        <th class="bg-light" scope="col">Type</th>
                                        <th class="bg-light" scope="col">Size</th>
                                        <th class="bg-light" scope="col">Access</th>
                                        <th class="bg-light" scope="col"></th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    <tr v-for="(upload, index) in uploads" :key="index" class="text-small cp" :class="{'tr-active':upload.selected == true,'bg-soft-danger':upload.error}" @click="select(index, $event)">
                                        <td data-label="File" scope="row">
                                            <div class="d-flex align-items-start">
                                                <div class="thumbnail thumbnail-sm mr-1" style="min-width: 48px; max-width: 48px; width: 48px;">
                                                    <i class="text-primary h4" :class="upload.icon"></i>
                                                </div>

                                                <span class="text-body" style="word-break: break-all;">{{upload.filename}}</span>
                                            </div>
                                        </td>
                                        <td data-label="Type">{{upload.filetype}}</td>
                                        <td data-label="Size">{{upload.filesize}}kb</td>
                                        <td data-label="Access">
                                            <!-- <span class="badge badge-dark" v-for="(access, index) in upload.access" :key="index">{{access}}</span> -->
                                            <button class="btn btn-sm btn-outline-dark" type="button" data-toggle="modal" data-target="#modal-access-dept" @click="selected_index = index">
                                                View File Access
                                            </button>
                                            <button class="btn btn-sm btn-outline-dark" type="button" data-toggle="modal" data-target="#modal-particulars" @click="selected_index = index">
                                                View File Particular
                                            </button>
                                        </td>
                                        <td data-label="">
                                        <div class="d-inline-block"> <!--dropdown -->
                                            <button class="btn btn-sm btn-outline-danger" type="button" @click="removeFile(index)">
                                                <i class="icon-trash"></i>
                                            </button>
                                            <!-- <button class="btn btn-sm btn-outline-primary dropdown-toggle dropdown-toggle-no-arrow" type="button" id="dropdownMenuButton-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="icon-dots-three-horizontal"></i>
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-sm">
                                                <a class="dropdown-item" @click="openFileAccess(index)">File Access</a>
                                                <a class="dropdown-item" @click="removeFile(index)">Remove</a>
                                            </div> -->
                                        </div>
                                        </td>
                                    </tr>


                                    </tbody>
                                </table>
                                <div class="card card-lg text-center b-0 h-100 mb-0 flex-1" v-else>
                                    <div class="d-flex flex-column card-body justify-content-center align-items-center">
                                    <i class="icon-add-to-list display-4 opacity-20"></i>
                                        <h1 class="h6">You haven't uploaded a file</h1>
                                        <small class="text-muted">Search Reference Number then click Tag Document to start uploading a file.</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="w-100 py-2 d-flex flex-row justify-content-end px-3" style="min-height: 60px; height: 60px; max-height: 60px;" v-if="validSearch">
                            <jl-button :class="'btn btn-success mr-2'" :eventClick="upload">Save</jl-button>
                            <button class="btn btn-dark" @click="reset">Reset</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--end of container-->
        </section>
       
 
    </div>
        <ModalFileAccess :department_props="departments" :callback="getDeparmentAccess" :selected_department="getCurrentAccessDepartment()" :category="category" />
        <ModalFileParticulars :callback="getParticular" :selected_particular="getCurrentParticular()" />
        <ModalEmbedLink :callback="submitLink" />
</template>

<script>
import ModalFileAccess from '../modal/FileAccess';
import ModalFileParticulars from '../modal/FileParticulars';
import ModalEmbedLink from '../modal/EmbedLink';
// import ModalFileAccess from './views/modal/FileAccess';

export default {
    components: {
        ModalFileAccess,
        ModalFileParticulars,
        ModalEmbedLink
    },
    data() {
        return {
            selected_index: -1, 
            loading_rm : false,
            doctypes: [],
            categories: [], 
            response: {},
            filetypes: {
                'image': 'icon-image',
                'pdf' : 'icon-clipboard',
                'text': 'icon-image',
                'application/vnd.openxmlformats-officedocument': 'icon-clipboard',
                'application/vnd.ms-excel': 'icon-clipboard',
                'link' : 'icon-link'
            },
            uploads: [
               
            ],
            validSearch: '',
            i_refno: '',
            i_reftype: '',
            t_refno: '',
            t_reftype: '',
            particular: '',
            description: '',
            category: {},
            departments: [], 
        }
    },
    computed: {

        checkRef(){
            if(this.i_reftype == 'CRF' || this.i_reftype == 'MIAF' || this.i_reftype == 'QUOTE' || this.i_reftype == 'MEMO') return true;
            
            return false
        }

    },
    methods: {
        reset() {
            this.uploads = [];
            this.validSearch = '';
            this.t_refno = '';
            this.t_reftype = '';
            this.i_refno = '';
            // this.i_reftype = '';
            this.particular = '';
            this.description = '';
            this.doctypes.filter(doctype => {
                doctype.val = '';
            });
            
        },
        resetTag() {
            this.t_refno = '';
            this.t_reftype = '';
        },
        search(e) {
            if(this.i_refno == '' || this.i_reftype == '') {
                this.$jlalert.show("Referrence number or type is required");
                this.$jlbutton.unload(e);
                return;
            }

            if(this.i_reftype.key <= 1 && this.t_reftype == '') this.resetTag();

            this.$axios.post('/searchref', this.$qs.stringify({refno:this.i_refno,reftype:this.i_reftype,trefno:this.t_refno,treftype:this.t_reftype}))
            .then(response => {
                this.$jlbutton.unload(e);
                // console.log(response);
                let data = response.data;
                this.response = data;

                this.particular = data['particular']

                this.description = data['description']
                

                // let files = data.files;
                // for(let i = 0; i < files.length; i ++) {
                //     const file = files[i];
                //     // this.uploads({
                //     //     filename: file.filename,
                //     // })
                // }

                // files.forEach(function(file) {
                //     // this.uploads({
                //     //     filename: file.filename,
                //     // })
                // });

                //[
            //     {
                    // ACCESS_DEPT: "11",
                    // COMMON_NUMBER: "1",
                    // ...
            //     }
                // ]

                //$dept = "1,2,3,4";
                //$array = explode(',', $dept); //[1,2,3,4]
                
                    this.uploads = data.files?  data.files.map(function(file) {
                    return {
                        icon: '',
                        trans_no: file.TRANS_NO,
                        filename: file.FILENAME,
                        filesize: file.FILESIZE,
                        filetype: file.FILETYPE,
                        access_dept: file.ACCESS_DEPT.split(','),
                        binary: '',
                        particulars: file.particular,
                        error: false,
                    }
                }):this.uploads= [];  
                
                //  if (this.uploads.length <= 0 ){
                //       this.$jlalert.show('No Reference  Data Found');
                //  }
               

                this.validSearch = this.i_refno;
                
            })
            .catch(error => {
                this.$jlbutton.unload(e);
                this.$jlalert.show(error);
            });

        },
        browseFile(e) {
            this.$jlbutton.unload(e);
            let input = document.createElement('input');
            input.setAttribute('type', 'file');
            // input.setAttribute('accept', 'image/*, application/pdf');
            input.setAttribute('multiple', 'multiple');
            input.addEventListener("change", this.handleFile);

            input.click();
        },
        async handleFile(e) {
            let files = e.target.files;

            // console.log(files);
            if(files.length) {
                files.filter
                for(var i = 0; i < files.length; i++) {
                    let file = files[i];
                    let icon;
                    let found = false;
                    for(var key in this.filetypes) {
                        if(file.type.indexOf(key) !== -1) {
                            found = true;
                            icon = this.filetypes[key];
                        }
                    }

                    if(!found) {
                        this.$jlalert.show({message:'Selected file type not allowed'});
                        return;
                    }
                    
                    let toBase64 = await this.convert(file).catch(e => Error(e));
                    if(toBase64 instanceof Error) {
                        this.$jlalert.show(toBase64.message);
                        return;
                    }

                    this.uploads.push({
                        icon: icon,
                        filename: file.name,
                        filesize: parseFloat(file.size / 1000).toFixed(2),
                        filetype: file.type,
                        access_dept: [],
                        binary: toBase64,
                        error: false
                    });
                }
            }
        },
        submitLink(link) {
            this.uploads.push({
                icon: this.filetypes.link,
                filename: link,
                filesize: 0,
                filetype: 'link',
                access_dept: [],
                binary: '',
                error: false
            });
        },
        convert(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        removeFile(index) {
            this.uploads.splice(index, 1);
        },
        upload(e) {
            // foreach($array as $el) {
            //        $el['filename'];
            // }

            // this.uploads.forEach(function(el) {
            //     var access_dept = el.access_dept; // [1,2,3,4,5,6]
            //     // $access_dept = array(1,2,3,4,5,6);
            //     // count($access_dept) == 0
            //     if(access_dept.length == 0) {
            //        this.$jlalert.show('File access is required');
            //        return false;
            //     }
            //     // if(el.filename === '') return 'empty string';
            //     // else if(el.access_dept == '')
            // });
            

            for(var i = 0; i < this.uploads.length; i++) {
                var upload_row = this.uploads[i]; 
                if(upload_row.access_dept.length == 0) {
                    console.log('this is empty', i);
                    this.$jlalert.show('File access is required');
                    this.$jlbutton.unload(e);
                    return false;
                }
            }

            this.$axios.post('/upload', this.$qs.stringify({data:this.uploads,reftype:this.i_reftype,refno:this.i_refno,trefno:this.t_refno,treftype:this.t_reftype,particular:this.particular,description:this.description,category:this.category}))
            .then(res => {
                this.$jlbutton.unload(e);
                if(res.status === 200) {
                    this.reset();
                }

                this.$jlalert.show(res.data, res.status !== 200);
                this.$jlbutton.unload(e);
            })
            .catch(error => {
                this.$jlbutton.unload(e);
                this.$jlalert.show(error);
            });
        },
        check() {
            this.validSearch = '';
            this.doctypes.filter(doctype => {
                doctype.val = '';
            }); 
        },
        select(index ,e) {
            if(e.target.tagName.toLowerCase() == 'input' || e.target.tagName.toLowerCase() == 'i' || e.target.tagName.toLowerCase() == 'button' || e.target.tagName.toLowerCase() == 'select' || e.target.tagName.toLowerCase() == 'a') {
                return;
            }
            this.uploads[index].selected = !this.uploads[index].selected;
        },
        removeSelected() {
            this.uploads = this.uploads.filter(upload => {
                return (upload.selected === false || upload.selected == undefined);
            });
        },
        async loadDepartments() {
            await this.$axios.get('/departments')
                    .then(res => {
                        this.departments = res.data;
                    })
                    .catch(err => {
                        console.error(err);
                        this.departments = [];
                    })
        },
        async loadCategory() {
            await this.$axios.get('/category')
                    .then(res => {                      
                        this.doctypes = res.data.ref;
                        this.categories = res.data.cat;
                        this.loading_rm = false;
                    })
                    .catch(err => {
                        console.error(err);
                        this.doctypes = [];
                         this.categories =[];
                    })
        },
        
        getDeparmentAccess(departments) {
            var selected_index = this.selected_index; // 0
            var current_file = this.uploads[selected_index]; //this.uploads[0]
            current_file.access_dept = departments // this.uploads[0].access_dept
            // [
            //     0 : {
            //         ..
            //         access_dept: ''
            //     },
            //     1: {
            //         filename: '',
            //         filetype: '',
            //         filesize: '',
            //         access_dept: ''
            //     },
            //     2: {
            //         ..
            //         access_dept: ''
            //     },
            // ]
        },
        getParticular(particular) {
            var selected_index = this.selected_index; // 0
            var current_file = this.uploads[selected_index]; //this.uploads[0]
            current_file.particulars = particular
        },
        getCurrentAccessDepartment() {
            var initialData = [];
            var selected_index = this.selected_index; // 0
            var current_file = this.uploads[selected_index]; //this.uploads[0]
            if(current_file !== undefined) {
                initialData = current_file.access_dept;
            }

            return initialData;
        },
        getCurrentParticular() {
            var initialData = '';
            var selected_index = this.selected_index; // 0
            var current_file = this.uploads[selected_index]; //this.uploads[0]
            if(current_file !== undefined) {
                initialData = current_file.particulars;
            }

            return initialData;
        },
        async getUserDepartment() {
            await this.$axios.get('/user_department')
                    .then(res => {
                        console.log(res.data);
                    })
                    .catch(err => {
                        console.error(err);
                    })
        },

        Myfunction(){
            console.log('FILE INSIDE')
        }
  
    },
    mounted() {
        // $('document').ready()
        this.loading_rm = true;
        this.loadDepartments();
        this.loadCategory();
        //this.getUserDepartment();
    },
    watch: {
        "category": function(newValue) {
            this.response = {};
            if(newValue.flag === 'Y') {
                this.i_reftype = {};
            }
            else {
                this.i_reftype = '';
            }

            if(newValue.name == 'CRF' || newValue.name == 'MIAF' || newValue.name == 'QUOTE' || newValue.name == 'MEMO'){
    

                this.i_reftype = newValue.name
            }
        }
    }
}
</script>

<style scoped>
img{
        filter: blur(1px);
        -webkit-filter: blur(1px);
}
label{
    color: white;
}
input,select,textarea{
    opacity : 0.9;
}
.sect1{
    opacity: 0.9;
}
.table.align-items-center th, .table.align-items-center td {
    vertical-align: top;
}

.reference-sticky {
    width: 25%
}

.reference-sticky .position-absolute {
    background: #fff;
}

.reference-sticky.collapse.show {
    width: 100% !important;
    display: flex !important;
    position: absolute !important;
    z-index: 99999 !important;
    height: 100% !important;
    top: 0 !important;
}

.reference-sticky.collapse.show .position-relative, .reference-sticky.collapse.show button[data-toggle="collapse"] {
    width: 65%;
}

.reference-sticky.collapse.show:after {
    background: #00000040;
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: -1;
}

.tr-active {
    background-color: #e9ecef !important;
}

.bg-soft-danger {
    background-color: #fbbfbb;
}

.bg-soft-danger td {
   border: 0;
}

.bg-soft-danger td * {
   color: #000;
}

.btn-search {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-top: 30px;
}

@media screen and (max-width: 767px) {
    .btn-search {
        margin-top: 10px;
        margin-left: 0 !important;
    }
}

</style>